// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"style_headerColumn__fRmCt3mEi5ebDHmtwP2ty","rowColumn":"style_rowColumn__2MQzOyzC7XSvcjkwbX0yRJ","center":"style_center__2C3NtrBvfAW-O9vjzT5HLj"};